import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useNotifications } from "../../../../hooks/useNotifications";
import { toTitleCase } from "../../../../common/TotitleCase";
import Breadcrumb from "../../../../utility/breadcrumb/Breadcrumb";
import { dummyNotifications } from "../../../../utils/dummyNotificationSettingData";

const NotificationSettings = () => {
    const { getTypeConfig,toggleEmail,togglePush,notificationPreferences,notificationsSetting,fetchNotificationsSetting } = useNotifications();
    const navigate = useNavigate();
    useEffect(() => {
        fetchNotificationsSetting();
    }, []);
    return (
        <>
            {/* Page Header */}
            <Breadcrumb title="Notification Settings"/>
            <div className="container-fluid p-0 py-2 rounded">

                {/* Notifications List */}
                {notificationsSetting.length > 0 ? (
                    <div className="row">
                        <div className="col-12">
                            <div
                                className="card border-0 shadow-lg"
                                style={{
                                    borderRadius: '0 0 24px 24px',
                                    // overflow: 'hidden',
                                    animation: 'fadeIn 0.8s ease 0.3s backwards'
                                }}
                            >
                                <div className="card-body p-0">
                                    {notificationsSetting.map((n, index) => {
                                        const relatedCfg = getTypeConfig(n.priority);
                                        const prefs = notificationPreferences[n.action_type] ?? {
                                        email: n.email_enabled,
                                        push: n.push_enabled
                                        };
                                        return (
                                            <React.Fragment key={n.action_type}>
                                                <div
                                                    className="notification-item p-2"
                                                    style={{
                                                        cursor: "pointer",
                                                        background: 'white',
                                                        animation: `slideInRight 0.5s ease ${index * 0.1}s backwards`
                                                    }}
                                                >
                                                    <div className="d-flex align-items-center gap-4">
                                                        {/* Icon */}
                                                        <div
                                                            className="flex-shrink-0 rounded-3 d-flex align-items-center justify-content-center"
                                                            style={{
                                                                width: '35px',
                                                                height: '35px',
                                                                background: relatedCfg.bg,
                                                                border: `2px solid ${relatedCfg.color}30`
                                                            }}
                                                        >
                                                            <i
                                                                className={`${relatedCfg.icon}`}
                                                                style={{ 
                                                                    color: relatedCfg.color,
                                                                    fontSize: '1.3rem'
                                                                }}
                                                            ></i>
                                                        </div>

                                                        {/* Title and Description */}
                                                        <div 
                                                            className="flex-grow-1 overflow-hidden"
                                                            // onClick={() => navigate(`/notification/${n.ticket_id}`)}
                                                        >
                                                            <h6 className="mb-1 kpi-name">
                                                                {toTitleCase(n.name)}
                                                            </h6>
                                                        </div>

                                                        {/* Toggle Buttons Container */}
                                                        <div className="d-flex gap-3 flex-shrink-0">

                                                        {/* Email Toggle */}
                                                        <div className="text-center">
                                                            <button
                                                            type="button"
                                                            className={`notification-toggle-btn ${prefs.email ? 'active' : ''} p-2`}
                                                            onClick={(e) => toggleEmail(n.action_type, prefs.email, e)}
                                                            style={{
                                                                width: "35px",
                                                                height: "35px",
                                                                border: "1px solid",
                                                                borderColor: prefs.email ? '#10b981' : '#e2e8f0',
                                                                color: prefs.email ? '#10b981' : '#94a3b8',
                                                                backgroundColor: prefs.email ? '#10b98110' : '#ffffff'
                                                            }}
                                                            title={prefs.email ? 'Email enabled' : 'Email disabled'}
                                                            >
                                                            <i className={`bi ${prefs.email ? 'bi-envelope-fill' : 'bi-envelope'}`} />
                                                            </button>
                                                        </div>

                                                        {/* Push Toggle */}
                                                        {/* <div className="text-center">
                                                            <button
                                                            type="button"
                                                            className={`notification-toggle-btn ${prefs.push ? 'active' : ''} p-2`}
                                                            onClick={(e) => togglePush(n.action_type, prefs.push, e)}
                                                            style={{
                                                                width: "35px",
                                                                height: "35px",
                                                                border: "1px solid",
                                                                borderColor: prefs.push ? '#f59e0b' : '#e2e8f0',
                                                                color: prefs.push ? '#f59e0b' : '#94a3b8',
                                                                backgroundColor: prefs.push ? '#f59e0b10' : '#ffffff'
                                                            }}
                                                            title={prefs.push ? 'Push notifications enabled' : 'Push notifications disabled'}
                                                            >
                                                            <i className={`bi ${prefs.push ? 'bi-bell-fill' : 'bi-bell-slash'}`} />
                                                            </button>
                                                        </div> */}

                                                        </div>

                                                        {/* Arrow Icon */}
                                                        <div 
                                                            className="flex-shrink-0"
                                                        >
                                                            <i
                                                                className="bi bi-chevron-right text-muted"
                                                                style={{ fontSize: '1.3rem' }}
                                                            ></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                {index < notificationsSetting.length - 1 && (
                                                    <div className="divider"></div>
                                                )}
                                            </React.Fragment>
                                        );
                                    })}
                                </div>

                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="row justify-content-center">
                        <div className="col-md-6 text-center">
                            <div 
                                className="card border-0 shadow-lg p-5 rounded-4"
                                style={{
                                    animation: 'fadeIn 0.8s ease'
                                }}
                            >
                                <div className="icon-wrapper mb-3">
                                    <div 
                                        className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                        style={{
                                            width: '120px',
                                            height: '120px',
                                            background: 'linear-gradient(135deg, #667eea20 0%, #764ba220 100%)',
                                            border: '3px dashed #667eea50'
                                        }}
                                    >
                                        <i className="bi bi-inbox display-1" style={{ color: '#667eea' }}></i>
                                    </div>
                                </div>
                                <h3 className="kpi-heading mb-2">
                                    No Notifications Yet
                                </h3>
                                <p className="kpi-name mb-4">
                                    You don't have any notifications to configure at the moment.
                                </p>
                                <button
                                    className="btn btn-lg rounded-pill px-5 shadow-sm mt-3"
                                    onClick={() => navigate(-1)}
                                    style={{
                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        border: 'none',
                                        fontWeight: '600',
                                        color: 'white'
                                    }}
                                >
                                    <i className="bi bi-arrow-left me-2"></i>
                                    Go Back
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default NotificationSettings;